module.exports = __webpack_public_path__ + "static/media/181EC206.0335d2d6.jpg";